import { openEnvironmentFileByPath } from "@/lib/environment-files";
import { PATH_LINK_CLASS } from "@/lib/link-styles";

/** 差分の対象ファイル名。押すとエディタで開く。 */
export function DiffFileLink({
	path,
	wrap = false,
}: {
	path: string;
	/** 1 行に切らず折り返して全体を出す。 */
	wrap?: boolean;
}) {
	return (
		<button
			type="button"
			title={wrap ? undefined : path}
			data-tooltip-if-truncated={wrap ? undefined : true}
			data-tooltip-nowrap={wrap ? undefined : true}
			onClick={() => {
				openEnvironmentFileByPath(path).catch((err: unknown) => {
					console.error("ファイルを開けませんでした", err);
				});
			}}
			className={`min-w-0 ${wrap ? "break-all" : "truncate"} ${PATH_LINK_CLASS} text-left font-mono text-caption`}
		>
			{path}
		</button>
	);
}
